module.exports = __webpack_public_path__ + "img/avalie-01.0278b3fa.png";